<script lang="ts">
  import { Col, Container, Image, Row } from "sveltestrap";
  import BookmarkGalleryGridDesc from "./BookmarkGalleryGridDesc.svelte";
  import Card from "../../../Core/Card.svelte";
  import { Gallarydata, IMAGEGALLERY, PortfolioTitle } from "../../../../utils/Constant/Constant";
  import data from "../../../../Data/Miscellaneous/Gallery.json"
  import { GalleryImage, GalleryThumbnail, LightboxGallery } from 'svelte-lightbox';
  let imgPath:string = "/assets/images"

</script>
<BookmarkGalleryGridDesc />
<Container fluid>
  <Row>
    <Col sm="12">
      <Card headerTitle={IMAGEGALLERY}>
        <div slot="contentbody">
          <div class="my-gallery gallery-with-description">
            <LightboxGallery> 
              <svelte:fragment slot="thumbnail">
                <Row class="sample-class-1">
                  {#each data.src as icon, i}
                    <Col xl="3"  md="4" sm="6" class="light-gallery">  
                      <GalleryThumbnail class="img-thumbnail p-3">   
                        <Image src="{imgPath}/{icon}" class="media mb-3" alt="Simple lightbox" />
                        <div class="caption"> 
                          <h4>{PortfolioTitle}</h4>
                          <p>{Gallarydata}</p>
                        </div>
                      </GalleryThumbnail>
                    </Col>
                  {/each}
                </Row>
              </svelte:fragment>
              {#each data.src as icon, i}
                <GalleryImage>
                  <Image src="{imgPath}/{icon}" alt="Simple lightbox" />
                  <div class="caption"> 
                      <h4>{PortfolioTitle}</h4>
                      <p>{Gallarydata}</p>
                  </div>
                </GalleryImage>
              {/each}
            </LightboxGallery>
          </div>
        </div>
      </Card>
    </Col>
  </Row>
</Container>